module.exports = __webpack_public_path__ + "img/icon_scan.18905527.svg";